import React from 'react'
import styled from 'styled-components'
import {icons} from 'utils/enums/icons'

const InputCell = styled.input`
    width: 100%;
    height: 100%;
    padding: 0 10px;

    + div {
        left: 0;
        right: 0;
        bottom: 0;
        content: "";
        position: absolute;
        transform: scaleX(0);
        transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
        border-bottom: 2px solid #415dd4;
        pointer-events: none;
    }

    &:focus {
        + div {
            transform: scaleX(1);
        }
    }
`

const Icon = styled.i`
    color: #a0b7be;
    font-size: 25px;
    padding-left: 10px;
`

const Sort = styled(Icon)`
    color: #415dd4;
    position: relative;
`

const Badge = styled.div`
    background-color: #ffc300;
    line-height: 16px;
    font-family: Helvetica;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    text-align: center;
    position: absolute;
    font-weight: 700;
    overflow: hidden;
    font-size: 12px;
    color: #fff;
    right: -5px;
    top: -3px;
`

const Cell = ({colId, sortingType, type, showSortingOrder, sortingOrder, defaultValue, editableHeader,
    handleBlur, handleFocus}) => {

    const onBlur = (e) => {
        if (e.target.value && e.target.value !== defaultValue) {
            handleBlur(e.target.value, colId)
        } else {
            e.target.value = defaultValue
        }
    }

    const onKeyDown = (e) => {
        if (e.keyCode === 13 || e.keyCode === 27) e.target.blur()
    }

    const onFocus = () => {
        handleFocus(colId)
    }

    return (
        <React.Fragment>
            {!sortingType && type &&
                <Icon className={icons[type.toLowerCase()]} />
            }
            {sortingType &&
                <Sort className={sortingType === 1  ? 'flicon-sort' : 'flicon-sort-alt'}>
                    {showSortingOrder && <Badge>{sortingOrder}</Badge>}
                </Sort>
            }
            <InputCell
                defaultValue={defaultValue}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                onFocus={onFocus}
                disabled={!editableHeader}
            />
            <div />
        </React.Fragment>
    )
}

export default React.memo(Cell)
